import {IDatasetSubset} from '../../../../Managers/Datasets/Types';

export const byId = (a: IDatasetSubset, b: IDatasetSubset) => {
  if (a.id > b.id) return 1;
  else if (b.id > a.id) return -1;
  else return 0;
};
